<div class="note-entry-page">
    <app-page-shell>
        <p-toast position="top-center" [life]="10000"></p-toast>
        <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

        <app-page-hero eyebrow="Payables" [title]="pageTitle"
            subtitle="Record vendor credits, link the original bill, and keep supplier context CRM-first.">
            <div actions>
                <p-button type="button" label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                    (click)="cancel()"></p-button>
                <p-button type="button" label="Save Credit Note" icon="pi pi-check" [loading]="isLoading"
                    [disabled]="creditNoteForm.invalid || !canSave" (click)="saveCreditNote()"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

        <form [formGroup]="creditNoteForm" (ngSubmit)="saveCreditNote()" class="note-workspace">
            <div class="note-main-column">
                <app-page-form-section title="Vendor and Source" icon="pi pi-users"
                    subtitle="Select the CRM vendor and original payable document.">
                    <div class="note-form-grid three">
                        <div class="field" *ngIf="editMode">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <input id="creditNoteNumber" type="text" pInputText formControlName="creditNoteNumber" readonly />
                                    <label for="creditNoteNumber">Credit Note #</label>
                                </p-iftalabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-select id="company" [options]="companies" formControlName="company"
                                        optionValue="value" optionLabel="label" [filter]="true" appendTo="body"
                                        (onChange)="onCompanyChange($event.value)" styleClass="w-full"></p-select>
                                    <label for="company">Company</label>
                                </p-iftalabel>
                            </p-inputGroup>
                            <small class="p-error" *ngIf="creditNoteForm.get('company')?.hasError('required') && creditNoteForm.get('company')?.touched">Company is required.</small>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-datePicker id="creditNoteDate" inputId="creditNoteDate" formControlName="creditNoteDate"
                                        dateFormat="yy-mm-dd" appendTo="body" styleClass="w-full"></p-datePicker>
                                    <label for="creditNoteDate">Credit Note Date</label>
                                </p-iftalabel>
                            </p-inputGroup>
                            <small class="p-error" *ngIf="creditNoteForm.get('creditNoteDate')?.hasError('required') && creditNoteForm.get('creditNoteDate')?.touched">Credit date is required.</small>
                        </div>

                        <app-crm-client-contact-picker class="span-2"
                            [clients]="crmClients"
                            [contacts]="crmContacts"
                            [selectedClient]="selectedCrmClient || null"
                            [selectedContact]="selectedCrmContact || null"
                            [clientRequired]="!!(creditNoteForm.get('crmClientId')?.invalid && creditNoteForm.get('crmClientId')?.touched)"
                            clientLabel="CRM Vendor"
                            contactLabel="Vendor Contact"
                            clientPlaceholder="Select vendor/supplier"
                            (selectedClientChange)="onCrmClientPicked($event)"
                            (selectedContactChange)="onCrmContactPicked($event)">
                        </app-crm-client-contact-picker>

                        <div class="field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon>
                            <p-iftalabel><input id="currencyCode" pInputText formControlName="currencyCode" maxlength="3" />
                                <label for="currencyCode">Currency code</label></p-iftalabel></p-inputGroup></div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-select id="customer" [options]="customers" formControlName="customer"
                                        optionValue="value" optionLabel="label" [filter]="true" [showClear]="true"
                                        appendTo="body" styleClass="w-full"></p-select>
                                    <label for="customer">Legacy Customer</label>
                                </p-iftalabel>
                            </p-inputGroup>
                        </div>

                        <div class="field span-2">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-autoComplete id="bill" formControlName="bill" [suggestions]="filteredBills" [dropdown]="true"
                                        (completeMethod)="filterBills($event)" (onSelect)="onBillSelected($event.value)"
                                        [forceSelection]="true" optionLabel="billNumber" appendTo="body" styleClass="w-full">
                                        <ng-template let-bill pTemplate="item">
                                            <div class="option-stack">
                                                <strong>{{ bill.odooBillNumber || bill.billNumber }}</strong>
                                                <span>{{ bill.crmDisplayName || bill.crmClient?.companyName || bill.mainParty?.entityName || '-' }}</span>
                                            </div>
                                        </ng-template>
                                    </p-autoComplete>
                                    <label for="bill">Original Bill</label>
                                </p-iftalabel>
                            </p-inputGroup>
                        </div>

                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <input id="supplierReference" pInputText maxlength="255" formControlName="supplierReference" />
                                    <label for="supplierReference">Supplier credit reference (required to submit)</label>
                                </p-iftalabel>
                            </p-inputGroup>
                        </div>
                        <div class="field">
                            <p-inputGroup>
                                <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
                                <p-iftalabel>
                                    <p-autoComplete id="invoice" formControlName="invoice" [suggestions]="filteredInvoices" [dropdown]="true"
                                        (completeMethod)="filterInvoices($event)" [forceSelection]="true" optionLabel="invoiceNumber"
                                        appendTo="body" styleClass="w-full">
                                        <ng-template let-invoice pTemplate="item">
                                            <span>{{ invoice.invoiceNumber }}</span>
                                        </ng-template>
                                    </p-autoComplete>
                                    <label for="invoice">Related Invoice</label>
                                </p-iftalabel>
                            </p-inputGroup>
                        </div>
                    </div>
                </app-page-form-section>

                <app-page-form-section title="Reason" icon="pi pi-comment"
                    subtitle="Describe the vendor credit reason for finance review.">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-info-circle"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input type="text" pInputText formControlName="reason" id="reason" />
                            <label for="reason">Reason</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </app-page-form-section>

                <app-page-data-panel title="Credit Note Lines"
                    subtitle="Use separate rows for audit-friendly vendor credit descriptions."
                    [resultText]="getCreditNoteLineControls.length + ' lines'">
                    <div actions>
                        <p-button type="button" label="Add Line" icon="pi pi-plus" severity="success"
                            (click)="addCreditNoteLine()"></p-button>
                    </div>
                    <div formArrayName="creditNoteLines" class="note-lines">
                        <div *ngFor="let lineGroup of getCreditNoteLineControls.controls; let i = index"
                            [formGroupName]="i" class="note-line-row">
                            <div class="line-index">Line {{ i + 1 }}</div>
                            <div class="field line-description">
                                <p-inputGroup>
                                    <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
                                    <p-iftalabel>
                                        <input type="text" pInputText formControlName="description" id="description{{ i }}" />
                                        <label for="description{{ i }}">Description</label>
                                    </p-iftalabel>
                                </p-inputGroup>
                            </div>
                            <div class="field line-amount">
                                <p-inputGroup>
                                    <p-inputGroupAddon><i class="pi pi-dollar"></i></p-inputGroupAddon>
                                    <p-iftalabel>
                                        <p-inputNumber inputId="amount{{ i }}" formControlName="amount" mode="decimal"
                                            [minFractionDigits]="4" [maxFractionDigits]="4" [min]="0"
                                            styleClass="w-full"></p-inputNumber>
                                        <label for="amount{{ i }}">Amount</label>
                                    </p-iftalabel>
                                </p-inputGroup>
                            </div>
                            <div class="field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-book"></i></p-inputGroupAddon>
                                <p-iftalabel><p-select [inputId]="'account' + i" formControlName="accountId" [options]="lineAccounts"
                                    optionLabel="label" optionValue="value" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
                                    <label [for]="'account' + i">Expense or asset account</label></p-iftalabel></p-inputGroup></div>
                            <div class="field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-percentage"></i></p-inputGroupAddon>
                                <p-iftalabel><p-select [inputId]="'taxCode' + i" formControlName="taxCode" [options]="taxCodes"
                                    optionLabel="taxCode" optionValue="taxCode" [filter]="true" appendTo="body" styleClass="w-full"></p-select>
                                    <label [for]="'taxCode' + i">Tax code</label></p-iftalabel></p-inputGroup></div>
                            <div class="field"><p-inputGroup><p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
                                <p-iftalabel><p-select [inputId]="'vatEligibility' + i" formControlName="inputVatRecoverable" [options]="vatEligibility"
                                    optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
                                    <label [for]="'vatEligibility' + i">Input VAT eligibility</label></p-iftalabel></p-inputGroup></div>
                            <p-button type="button" *ngIf="getCreditNoteLineControls.controls.length > 1"
                                icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true"
                                pTooltip="Remove line" (click)="removeCreditNoteLine(i)"></p-button>
                        </div>
                    </div>
                </app-page-data-panel>
            </div>

            <aside class="note-side-column">
                <app-page-data-panel title="Document Summary" [resultText]="formatMoney(total)">
                    <div class="note-summary">
                        <div>
                            <span>Vendor</span>
                            <strong>{{ selectedVendorName }}</strong>
                        </div>
                        <div>
                            <span>Subtotal</span>
                            <strong>{{ formatMoney(subtotal) }}</strong>
                        </div>
                        <div>
                            <span>Estimated tax</span>
                            <strong>{{ formatMoney(tax) }}</strong>
                        </div>
                        <div>
                            <span>Estimated total</span>
                            <strong class="success">{{ formatMoney(total) }}</strong>
                        </div>
                    </div>
                </app-page-data-panel>
            </aside>
        </form>
    </app-page-shell>
</div>
